import { ConfigPatch } from 'src/config/types';

export default (): ConfigPatch => ({
    tracking: {
        tagmanager: {
            tagCode: 'GTM-56RH',
        },
    },
    host: 'www.zalando-prive.fr',
});
